import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleChangeValue, handlePost } from '../../../../../utils/AxiosUtil';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTimePicker from '../../../../common/inputfields/ErrorAwareTimePicker';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../../common/inputfields/NewAgainField';
import { getFromLocalStorage } from "../../../../../utils/Util";

class NewOccasionalSalary extends Component {

    state = {
        newAgain: false,
        amount: '',
        employeeName: '',
        date: new Date(),
        startTime: "08:00",
        endTime: "16:00",
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            amount: '',
            employeeName: '',
            date: new Date(),
            startTime: "08:00",
            endTime: "16:00",
            errors: new Map(),
        })
        this.setAmount();
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/occasionalsalary';
        const requestObject = {
            "amount": util.toNumber(this.state.amount),
            "name": this.state.employeeName,
            "date": this.state.date,
            "startTime": this.state.startTime,
            "endTime": this.state.endTime
        };
        handlePost(path, requestObject, this);
    };

    componentDidMount() {
        this.setAmount();
    };

    setAmount() {
        console.log(this.props);
        const cookies = getFromLocalStorage("Alkalmi Fizetések", 'settings');
        console.log(cookies);
        let value = ''
        if (cookies) {
            cookies.forEach(function (obj) {
                if (obj.name === 'occasionalSalaryAmount') {
                    value = obj.value;
                }
            })
            this.setState({ amount: value })
        }
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="employeeName"
                            label="Név"
                            autoComplete="on"
                            errors={this.state.errors}
                            value={this.state.employeeName}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="amount"
                            label="Összeg"
                            errors={this.state.errors}
                            value={this.state.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            onChange={v => handleChangeValue(v, "date", this)} />
                    </div>
                    <div className='input-group'>
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTimePicker
                            required
                            name="startTime"
                            label="Kezdő időpont"
                            errors={this.state.errors}
                            value={this.state.startTime}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTimePicker
                            required
                            name="endTime"
                            label="Befejezés időpont"
                            errors={this.state.errors}
                            value={this.state.endTime}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewOccasionalSalary);
